/**
 * @generated SignedSource<<671e78dbd0ffc3a289bf0ea52a0d126d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type MilestoneRow$data = {
  readonly description: string | null | undefined;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"MilestoneDate" | "MilestoneRowMetadata" | "MilestoneRowTitle">;
  readonly " $fragmentType": "MilestoneRow";
};
export type MilestoneRow$key = {
  readonly " $data"?: MilestoneRow$data;
  readonly " $fragmentSpreads": FragmentRefs<"MilestoneRow">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MilestoneRow",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MilestoneRowTitle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MilestoneRowMetadata"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MilestoneDate"
    }
  ],
  "type": "Milestone",
  "abstractKey": null
};

(node as any).hash = "25d31e44c8e8ab527e5098c3a9a57222";

export default node;
